import React, { Component } from 'react';
import HeaderSardinhas from '../../assets/images/sardinhas/__header.png';
import ImageCozido from '../../assets/images/sardinhas/__cozido.png';
import ImageMelancia from '../../assets/images/sardinhas/__melancia.png';
import ImageFloresta from '../../assets/images/sardinhas/__floresta.png';
import ImageBoasVidas from '../../assets/images/sardinhas/__boasvidas.png';
import ProjectHeader from '../ProjectHeader';

import { store, showPreview } from '../_App/redux';

class ProjectSardinhas extends Component {
	sardinhas = [{
		src: ImageCozido
	}, {
		src: ImageMelancia
	}, {
		src: ImageFloresta
	}, {
		src: ImageBoasVidas
	}];

	openPreview(index) {
		store.dispatch(showPreview(this.sardinhas[index].src));
	}

	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Sardinhas</h1>
				<span className="title-caption step-4">"Festas de Lisboa" Sardine Contest</span>
				<div className="publish-container">
					<img src={HeaderSardinhas} alt="Caption for single" />
					<p>
						Every year before the festivities period ({' '}
						<a
							href="https://egeac.pt/"
							target="_blank"
							className="link"
						>
							"Festas de Lisboa"
						</a>{' '}
						, in June) there's an open contest to create the image from a sardine a silhouette that will be
						used as part of the Festas de Lisboa's campaign. Here are some of my entries.
					</p>

					<h3>Cozido à portuguesa's Sardine</h3>
					<p>
						Cozido is a{' '}
						<a href="https://www.wikiwand.com/en/Cozido_%C3%A0_portuguesa" target="_blank" className="link">
							traditional Portuguese stew
						</a>.
					</p>
					<img className="gallery__image hoverable" src={ImageCozido} alt="Cozido à portuguesa's Sardine" onClick={() => { this.openPreview(0) }} />

					<h3>Watermelon's Sardine</h3>
					<img className="gallery__image hoverable" src={ImageMelancia} alt="Watermelon's Sardine" onClick={() => { this.openPreview(1) }} />

					<h3>Sardine in the woods</h3>
					<img className="gallery__image hoverable" src={ImageFloresta} alt="Sardine in the woods" onClick={() => { this.openPreview(2) }} />

					<h3>The good life, but for all</h3>
					<img className="gallery__image hoverable" src={ImageBoasVidas} alt="The good life, but for all" onClick={() => { this.openPreview(3) }} />

					<br />
					<p>Thank you.</p>
				</div>
			</div>
		);
	}
}

export default ProjectSardinhas;
